import PropTypes from 'prop-types';
export var EventPropType = PropTypes.shape({
  category: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.number,
  nonInteraction: PropTypes.bool
});